"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PermissionMap = void 0;
const perm = __importStar(require("../utils/permissions"));
class PermissionMap extends Map {
    static from(perms) {
        const pm = new PermissionMap();
        perms.map((p) => {
            pm.set(p, true);
        });
        return pm;
    }
    requiresSetup(setupRequired) {
        if (setupRequired) {
            for (const item of this.keys()) {
                if (perm.REQUIRES_SETUP_COMPLETE_CURRENCY.indexOf(item) > 0) {
                    this.delete(item);
                }
            }
        }
        return this;
    }
}
exports.PermissionMap = PermissionMap;
